import React from 'react';
import { Route, Switch } from 'react-router';

import { SignInPage } from 'containers/SignInPage';
import { AppRoutingShared } from 'containers/AppRouting/AppRoutingShared';

export const AppRoutingGuest = () => {
  return (
    <Switch>
      <Route path="/" exact>
        <SignInPage />
      </Route>

      <Route path="/">
        <AppRoutingShared />
      </Route>
    </Switch>
  );
};
